'use client'

import { memo, useEffect, useMemo, useState } from 'react'
import { cn } from '@/lib/utils'

type VoiceWaveBarsProps = {
  active: boolean
  bars?: number
  className?: string
}

/** baby: Thin bar visualizer: animates only while listening. */
export const VoiceWaveBars = memo(function VoiceWaveBars({
  active,
  bars = 36,
  className,
}: VoiceWaveBarsProps) {
  const [tick, setTick] = useState(0)

  useEffect(() => {
    if (!active) return undefined

    let frameId = 0
    const loop = () => {
      setTick((current) => current + 1)
      frameId = window.requestAnimationFrame(loop)
    }

    frameId = window.requestAnimationFrame(loop)
    return () => window.cancelAnimationFrame(frameId)
  }, [active])

  const heights = useMemo(() => {
    return Array.from({ length: bars }, (_, index) => {
      if (!active) return 4
      const wave =
        Math.sin((index + tick * 0.08) * 0.62) * 0.5 +
        Math.sin((index * 0.31 + tick * 0.05) * 1.4) * 0.25 +
        0.5
      return 4 + wave * 28
    })
  }, [active, bars, tick])

  return (
    <div className={cn('ninxl-inkflow-wave-bars', className)} aria-hidden>
      {heights.map((height, index) => (
        <span
          key={index}
          className={cn('ninxl-inkflow-wave-bar', active && 'ninxl-inkflow-wave-bar-active')}
          style={{ height: `${height}px` }}
        />
      ))}
    </div>
  )
})
